import { render, staticRenderFns } from "./OriginRecord.vue?vue&type=template&id=945e7aba&scoped=true&"
import script from "./OriginRecord.vue?vue&type=script&lang=js&"
export * from "./OriginRecord.vue?vue&type=script&lang=js&"
import style0 from "./OriginRecord.vue?vue&type=style&index=0&id=945e7aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945e7aba",
  null
  
)

export default component.exports